/* import __COLOCATED_TEMPLATE__ from './new.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class SignInTokenStatesNew extends Component {}
